import {RATE} from '../../common/scripts/constants';

import template from './rates.twig';

class Rates {
    constructor($ratesWrap, afterBindTebmplate) {
        this.template = template;
        this.$ratesWrap = $ratesWrap;
        this.afterBindTebmplate = afterBindTebmplate;
    }

    init() {
        this._send();
    }

    _send() {
        const settings = {
            headers: {'Content-Type': `application/json`},
            method : `GET`
        };

        fetch(RATE, settings)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`${response.status}: ${response.statusText}`);
                }

                return response.json();
            })
            .then((data) => {
                const adaptedDataRates = this._adaptDataRatesForTemplate(data.rates);

                this._insertTemplete(adaptedDataRates);

                if (this.afterBindTebmplate) {
                    this.afterBindTebmplate();
                }
            });
    }

    _adaptDataRatesForTemplate(rates) {
        const adaptRates = [];

        for (const name in rates) {
            const adaptRate = this._getAdaptRate(rates[name], name);

            if (adaptRate.value) {
                adaptRates.push(adaptRate);
            }
        }

        return adaptRates;
    }

    _getAdaptRate(rates, name) {
        const nameTo = name === 'GVT' ? 'BTC' : 'USD';
        const rateNameTo = rates.find((elem) => {
            return elem.currency === nameTo;
        });

        return {
            nameTo,
            nameFrom: name,
            value   : rateNameTo.rate
        };
    }

    _insertTemplete(dataRates) {
        this.$ratesWrap.append(this.template({rates: dataRates}));
    }
}

export default Rates;
